import CssBaseline from '@mui/material/CssBaseline';
import {
  ThemeProvider,
  StyledEngineProvider,
  createTheme,
} from '@mui/material/styles';

import componentsOverride from './overrides';

interface ThemeConfigParams {
  children: JSX.Element | JSX.Element[];
}

export default function ThemeConfig({
  children,
}: ThemeConfigParams): JSX.Element {
  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 576,
        md: 768,
        lg: 1200,
        xl: 1400,
      },
    },
    palette: {
      primary: {
        main: '#36B7E8',
        light: '#36B7E81A',
      },
      background: {
        default: '#fff',
      },
      grey: {
        50: '#F7F7F7',
        300: '#E4E6EF',
        400: '#A6A6A6',
        500: '#545454',
        600: '#686479',
        700: '#7B7D7D',
      },
    },
    typography: {
      button: {
        textTransform: 'none',
      },
      fontFamily: 'Inter, sans-serif',
      h1: {
        fontSize: '2.1875rem',
        fontWeight: 700,
        letterSpacing: '.02rem',
        color: '#36B7E8',
      },
      h2: {
        fontSize: '1.5875rem',
        fontWeight: 700,
        color: '#545454',
        textAlign: 'center',
      },
      subtitle1: {
        fontSize: '1rem',
        fontWeight: 500,
        lineHeight: '1.5rem',
        color: '#545454',
      },
      subtitle2: {
        fontSize: '1.125rem',
        fontWeight: 500,
        lineHeight: '1.5rem',
        letterSpacing: '0.02rem',
        color: '#545454',
      },
      body1: {
        fontSize: '.8rem',
        letterSpacing: '0.02rem',
        color: '#7B7D7D',
      },
      body2: {
        lineHeight: '1.25rem',
        letterSpacing: '0.02rem',
        color: '#7B7D7D',
      },
    },
  });

  theme.components = componentsOverride(theme);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
